// Modèle de filtres par colonne pour les tableaux d'opérations
// (compte commun et budget personnel). Tout est appliqué en mémoire.

export type SplitType =
  | 'proportional'
  | 'equal'
  | 'custom'
  | 'partner1_only'
  | 'partner2_only';

export const SPLIT_TYPES: SplitType[] = [
  'proportional',
  'equal',
  'custom',
  'partner1_only',
  'partner2_only',
];

export type StatusFlag = 'internalTransfer' | 'coupleIncome' | 'sharedExpense';

export interface OperationColumnFilters {
  date: {
    start: string; // YYYY-MM-DD ou ''
    end: string; // YYYY-MM-DD ou ''
  };
  description: {
    categoryId: string;
    subcategoryId: string;
    text: string;
  };
  amount: {
    min: string;
    max: string;
    types: ('credit' | 'debit')[];
  };
  status: {
    validation: ('validated' | 'unvalidated')[];
    recurrence: ('recurring' | 'oneoff')[];
    flags: StatusFlag[];
    splitTypes: SplitType[];
  };
}

export const EMPTY_FILTERS: OperationColumnFilters = {
  date: { start: '', end: '' },
  description: { categoryId: '', subcategoryId: '', text: '' },
  amount: { min: '', max: '', types: [] },
  status: { validation: [], recurrence: [], flags: [], splitTypes: [] },
};

// Helpers « un filtre est-il actif sur cette colonne ? » (pastille de l'icône)
export const isDateFilterActive = (f: OperationColumnFilters): boolean =>
  !!(f.date.start || f.date.end);

export const isDescriptionFilterActive = (f: OperationColumnFilters): boolean =>
  !!(f.description.categoryId || f.description.text.trim());

export const isAmountFilterActive = (f: OperationColumnFilters): boolean =>
  !!(f.amount.min || f.amount.max || f.amount.types.length);

export const isStatusFilterActive = (f: OperationColumnFilters): boolean =>
  !!(
    f.status.validation.length ||
    f.status.recurrence.length ||
    f.status.flags.length ||
    f.status.splitTypes.length
  );

export const isAnyFilterActive = (f: OperationColumnFilters): boolean =>
  isDateFilterActive(f) ||
  isDescriptionFilterActive(f) ||
  isAmountFilterActive(f) ||
  isStatusFilterActive(f);
